import { Component, ViewChild } from '@angular/core';
import { BookingService } from '../../api/services';
import {
  WalletTransferItem,
  WalletTransferItemWithOwner,
} from '../../api/models';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { environment } from '../../../environments/environment';
import {
  enumPayoutAccountStatus,
  enumPayoutTransferStatus,
} from '../../shared/models/enum-wallet';
import { WalletTransferSetStatusComponent } from './wallet-transfer-set-status/wallet-transfer-set-status.component';

@Component({
  selector: 'app-wallet-transfers',
  templateUrl: './wallet-transfers.component.html',
  styleUrl: './wallet-transfers.component.scss',
})
export class WalletTransfersComponent {
  @ViewChild('dt1') table?: Table;
  list: WalletTransferItemWithOwner[] = [];
  count = 0;
  enumPayoutAccountStatus = enumPayoutAccountStatus;
  loading = false;
  account_menu: MenuItem[] | undefined;
  environmentMediaUrl = environment.mediaUrl;
  selectedTransfer?: WalletTransferItemWithOwner;
  modalSetStatus: DynamicDialogRef | undefined;
  enumPayoutTransferStatus = enumPayoutTransferStatus;

  constructor(
    public dialogService: DialogService,
    private boService: BookingService,
  ) {}

  ngOnInit() {
    this.account_menu = [
      {
        label: 'Cambia stato',
        icon: 'pi pi-pencil',
        command: () => {
          this.modalSetStatus = this.dialogService.open(
            WalletTransferSetStatusComponent,
            {
              header: 'Modifica stato',
              width: '50%',
              focusOnShow: false,
              data: {
                transfer: this.selectedTransfer,
              },
            },
          );
          this.modalSetStatus.onClose.subscribe((c: { done: boolean }) => {
            if (c && c.done === true) {
              this.fetch(this.table?.createLazyLoadMetadata());
            }
          });
        },
      },
    ];
  }

  fetch(event: TableLazyLoadEvent) {
    this.loading = true;
    this.boService
      .bookingControllerGetWalletTransfersAll({
        limit: +event.rows!,
        skip: +event.first!,
        for_gmg_wallet: false,
      })
      .subscribe((r) => {
        this.list = r.data.list;
        this.count = r.data.count;
        this.loading = false;
      });
  }
}
